import { StyleSheet } from 'react-native';

export const COLORS = {
    primary: '#4f46e5', // indigo-600
    primaryLight: '#eef2ff', // indigo-50
    secondary: '#4b5563', // gray-600
    accent: '#8b5cf6', // purple-500 for gradient effects
    white: '#ffffff',
    black: '#000000',
    success: '#22c55e', // green-500
    error: '#ef4444', // red-500
    warning: '#f97316', // orange-500
    
    // UI Colors
    background: '#f8fafc', // slate-50
    border: '#e2e8f0', // slate-200
    text: '#0f172a', // slate-900
    textSecondary: '#64748b', // slate-500
    textTertiary: '#94a3b8', // slate-400

    // Reds
    red: '#ef4444', // red-500
    red50: '#fef2f2',
    red200: '#fecaca',
    red700: '#b91c1c',
    red900: '#7f1d1d',

    // Yellows
    yellow: '#eab308', // yellow-500
    yellow50: '#fefce8',
    yellow200: '#fef08a',
    yellow700: '#a16207',
    yellow900: '#713f12',

    // Blues
    blue: '#3b82f6', // blue-500
    blue50: '#eff6ff',
    blue200: '#bfdbfe',
    blue700: '#1d4ed8',
    blue900: '#1e3a8a',

    // Grays / Slates
    slate50: '#f8fafc',
    slate100: '#f1f5f9',
    slate200: '#e2e8f0',
    slate300: '#cbd5e1',
    slate400: '#94a3b8',
    slate500: '#64748b',
    slate600: '#475569',
    slate700: '#334155',
    slate800: '#1e293b',
    slate900: '#0f172a',
};

export const commonStyles = StyleSheet.create({
    safeArea: {
        flex: 1,
        backgroundColor: COLORS.slate100,
    },
    container: {
        flex: 1,
        padding: 24,
        backgroundColor: COLORS.white,
    },
    title: {
        fontSize: 24,
        fontWeight: 'bold',
        color: COLORS.slate900,
        textAlign: 'center',
    },
    description: {
        fontSize: 16,
        color: COLORS.slate500,
        textAlign: 'center',
        marginTop: 8,
    },
    button: {
        backgroundColor: COLORS.primary,
        paddingVertical: 16,
        borderRadius: 12,
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonText: {
        color: COLORS.white,
        fontSize: 16,
        fontWeight: 'bold',
    },
    buttonDisabled: {
        backgroundColor: COLORS.slate400,
    },
    input: {
        borderWidth: 1,
        borderColor: COLORS.slate300,
        borderRadius: 8,
        padding: 16,
        fontSize: 16,
        backgroundColor: COLORS.white,
    },
    label: {
        fontSize: 14,
        fontWeight: '500',
        color: COLORS.slate700,
        marginBottom: 8,
    },
    errorText: {
        color: COLORS.error,
        textAlign: 'center',
        marginBottom: 12,
    },
    linkText: {
        color: COLORS.primary,
        fontWeight: '600',
    },
});